import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from 'lexical';
import { useEffect } from 'react';

/**
 * Plugin to expose the Lexical editor instance to the parent via a callback.
 */
export function ExposeEditorInstancePlugin({ onReady }: { onReady: (editor: any) => void }) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (editor) onReady(editor);
  }, [editor, onReady]);
  return null;
}

/**
 * Plugin to handle sending a message on Enter key press.
 * Calls onSubmit when Enter is pressed (but not Shift+Enter) and not loading.
 */
export function SendOnEnterPlugin({
  onSubmit,
  isLoading,
}: {
  onSubmit: () => void;
  isLoading: boolean;
}) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        // Check if Shift key is pressed - if so, allow default behavior (new line)
        if (event && 'shiftKey' in event && event.shiftKey) {
          return false; // Let the default behavior handle Shift+Enter (new line)
        }

        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        if (!isLoading) onSubmit();
        return true;
      },
      COMMAND_PRIORITY_HIGH
    );
  }, [editor, onSubmit, isLoading]);
  return null;
}
